// extracted by mini-css-extract-plugin
export default {"cls1":"OS8s9UuEGNaao9h2OfME","cls2":"PDc11vd3ob9D4cgU7DDw OS8s9UuEGNaao9h2OfME"};